import { Container, Row, Col } from "react-bootstrap";

function Footer() {
	return (
		<footer
			className="fixed-bottom"
			style={{
				marginTop: 1,
				backgroundColor: "#039ee3",
				color: "#ffffff",
				paddingTop: 10,
				fontSize: 10,
			}}
		>
			<Container>
				<Row>
					<Col
						className={{
							textAlign: "center",
							marginRight: "3rem",
							paddingTop: "2rem",
						}}
					>
						<p></p>
					</Col>
				</Row>
			</Container>
		</footer>
	);
}

export default Footer;
